
import React, { useEffect, useState, useRef } from "react";
import { useLocation, Route, Switch, useHistory } from "react-router-dom";
import AdminNavbar from "components/Navbars/AdminNavbar";
import Sidebar from "components/Sidebar/Sidebar";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import routes from "routes.js";
import "./Admin.css";
import sidebarImage from "assets/img/sidebar-3.jpg";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/app/index.css";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

function Admin() {
    const theme = useTheme();
    const md_matches = useMediaQuery(theme.breakpoints.down('md'));
    const sm_matches = useMediaQuery(theme.breakpoints.down('sm'));
    const [image, setImage] = useState(sidebarImage);
    const [color, setColor] = useState("black");
    const [hasImage, setHasImage] = useState(true);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const location = useLocation();
    const history = useHistory();
    const mainPanel = useRef(null);
    let logoutTimer = useRef(null);

    const resetTimer = () => {
        if (logoutTimer.current) clearTimeout(logoutTimer.current);
        logoutTimer.current = setTimeout(() => {
            localStorage.removeItem("authToken"); 
            toast.error("Your Sesstion Is Expired...");
            history.push("/"); 
        }, 6000000000); 
    };

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        if (mainPanel.current) mainPanel.current.scrollTop = 0;

        if (
            window.innerWidth < 993 &&
            document.documentElement.className.indexOf("nav-open") !== -1
        ) {
            document.documentElement.classList.toggle("nav-open");
            var element = document.getElementById("bodyClick");
            if (element) element.parentNode.removeChild(element);
        }
    }, [location]);

    useEffect(() => {
        resetTimer(); // Start timer on mount
        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("keydown", resetTimer);
        window.addEventListener("click", resetTimer);
        return () => {
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("keydown", resetTimer);
            window.removeEventListener("click", resetTimer);
            if (logoutTimer.current) clearTimeout(logoutTimer.current);
        };
    }, []);

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.layout === "/admin") {
                return (
                    <Route
                        path={prop.layout + prop.path}
                        render={(props) => <prop.component {...props} />}
                        key={key}
                    />
                );
            } else {
                return null;
            }
        });
    };

    return (
        <>
            <div className="wrapper">
                <Sidebar color={color} image={hasImage ? image : ""} routes={routes} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
                <div className="main-panel" ref={mainPanel}>
                    <AdminNavbar />
                    <div className="content">
                        <Switch>{getRoutes(routes)}</Switch>
                    </div>
            {md_matches?<div style={{marginTop:'5%'}} className="footerAs">Powered by CAMSEC.AI</div>:<div style={{marginTop:'6%'}} className="footerA">Powered by CAMSEC.AI</div>}
                    </div>
            </div>
           
        </>
    );
}

export default Admin;
